import Cache from "../cache/";
import _ from "lodash";
import Constants from "../config/Constants";
import axios from "axios";
import Cookies from 'universal-cookie';
import appConfig from "../config/AppConfig";
import { AjaxService as AjaxServiceElectron } from "./AjaxServices.electron.js";


// defined a variable to store service url string format
const serviceUrl = "/Services/AjaxRequestHandler.ashx?class=imLeagues.Web.Members.Services.BO.{0}&method={1}&paramType=imLeagues.Internal.API.VO.Input.{2}&urlReferrer={3}";
// defined a variable to store ajax service with writable session call url string format
const serviceUrlWithWritableSession =
    "/Services/AjaxRequestHandlerWithWritableSession.ashx?class=imLeagues.Web.Members.Services.BO.{0}&method={1}&paramType=imLeagues.Internal.API.VO.Input.{2}&urlReferrer={3}";

class AjaxService {
    constructor() {
        this.api = axios.create({
            //baseURL: 'https://some-domain.com/api/',
            //baseURL: appConfig.AJAX_SERVICE_BASE,
            timeout: 1000,
            headers: { "Cache-Control": "no-cache", "Accept-Language": "en-US, en", "Content-Type": "application/json", Authorization: "" },
        });

        this.keyCache = new Cache(50000);
        this.dataCache = new Cache(50000);

        // define how many ms we wait before we start to check validity of cached data
        this.validityCheckDelay = 5000; // 5 seconds
    }

    callAjax = (httpService, serviceUrl, jsonData, successCallback, failureCallback) => {
        const config = { headers: {} };

        const jwtTokenForSPA = window.localStorage.getItem("JwtTokenForSPA");
        //use a startswith polyfill here since the ie do not support this function
        //return this.substr(position || 0, searchString.length) === searchString;
        if (jwtTokenForSPA && jwtTokenForSPA !== "" && serviceUrl.substr(0, "http://".length) === "http://") {
            config.headers = { Authorization: "Bearer " + jwtTokenForSPA };
        }

        httpService
            .post(serviceUrl, jsonData, config)
            .then((rawResponse) => {
                const response = rawResponse.data;
                //httpService.post(serviceUrl, jsonData).success(function (response) {
                if (response.isDone) {
                    console.info("Correlation id: " + response.correlationId + ". Please provide this correlation id if you need an investigation from IMLeagues.");

                    if (response.jwtTokenIndexForSPA) {
                        if (response.jwtTokenIndexForSPA === -1) {
                            window.localStorage.setItem("JwtTokenForSPA", "");
                            window.localStorage.setItem("JwtTokenIndexForSPA", -1);
                        } else if (response.jwtTokenIndexForSPA > -1) {
                            window.localStorage.setItem("JwtTokenForSPA", response.jwtTokenForSPA);
                            window.localStorage.setItem("JwtTokenIndexForSPA", response.jwtTokenIndexForSPA);
                        }
                    }

                    if (!this.isUndefOrNull(successCallback)) {
                        successCallback(response);
                    }
                } else {
                    console.error("Correlation id: " + response.correlationId + ". Please provide this correlation id to facilitate IMLeagues investigation on this issue.");

                    // for any non-authenticated request, redirect users to login page
                    // for authentication
                    let errorCode = response.code;
                    if (response.data && response.data.code) {
                        errorCode = response.data.code;
                    }

                    switch (errorCode) {
                        case Constants.CODES.SPA_CLIENT_OLD:
                            window.location.reload();
                            return;
                        case Constants.CODES.ACCESS_VIOLATION:
                        case Constants.CODES.TO_BE_AUTHENTICATED:
                            {
                                let paraPrefix = "?";
                                if (response.data.indexOf("?") !== -1) paraPrefix = "&";

                                //for member fill survey page, we will try redirect to the network/portal fill page, so if you are in this page being redirect we will ignore the redirect
                                if (window.location.href.indexOf("spa/member/fillsurvey") > -1) {
                                    //redirect after 10 sec if nothing happens
                                    setTimeout(  () =>{
                                        window.location.href = response.data + paraPrefix + "redirecturl=" + encodeURIComponent(window.location.href);
                                    }, 10 * 1000);
                                } else {
                                    window.location.href = response.data + paraPrefix + "redirecturl=" + encodeURIComponent(window.location.href);
                                    return;
                                }
                            }
                            break;
                        case Constants.CODES.MUST_BE_SCHOOL_MEMBER:
                            {
                                const schoolID = response.data;
                                window.location.href = "/Members/JoinSchoolGuide.aspx?SchId=" + schoolID + "&redirecturl=" + encodeURIComponent(window.location.href);
                            }
                            return;
                        case Constants.CODES.SPA_DISABLED:
                            window.location.href = Constants.PAGES.MEMBER_HOME;
                            return;
                        case Constants.CODES.REQUIRE_SIGN_WAIVERS:
                            window.location.href = Constants.PAGES.SIGN_WAIVER_REQUESTS;
                            return;
                        case Constants.CODES.REQUIRE_SET_PASSWORD:
                            window.location.href = Constants.PAGES.CHANGE_PASSWORD;
                            return;
                        case Constants.CODES.REQUIRE_COMPLETE_REGISTRATION:
                            window.location.href = Constants.PAGES.COMPLETE_REGISTRATION + "?ReturnUrl=" + encodeURIComponent(window.location.href);
                            return;
                        case Constants.CODES.REQUIRE_LINK_FACEBOOK:
                            window.location.href = Constants.PAGES.LINK_FACEBOOK;
                            return;
                        case Constants.CODES.REQUIRE_SSO_SET_PASSWORD:
                            window.location.href = Constants.PAGES.SSO_SET_PASSWORD;
                            return;
                        case Constants.CODES.REQUIRE_HTTPS:
                            window.location.href = window.location.href.replace("http://", "https://");
                            return;
                        case Constants.CODES.INVALID_SPA_ROUTE_ID:
                            window.location.href = Constants.PAGES.PAGE_NOT_FOUND;
                            return;
                        case Constants.CODES.REQUIRE_SIGNED_WAIVER:
                            window.location.href = Constants.PAGES.SIGN_WAIVER_PROMPT;
                            return;
                    }

                    if (!this.isUndefOrNull(failureCallback)) {
                        failureCallback(response);
                    }
                }
            })
            .catch(  (error) =>{
                console.error("Failed to call " + serviceUrl);
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });
    }

    ajax = (serviceUrl, jsonData, successCallback, failureCallback) => {
        // initialize jsonData if it is null or undefined
        if (this.isUndefOrNull(jsonData)) {
            jsonData = {};
        }

        // set clientVersion for all ajax call
        jsonData.clientVersion = window.g_clientVersion;

        // detect whether to show mobile ads or not
        jsonData.isMobileDevice = this.detectIsMobileDevice();

        //Get isSSO from Cookie
        jsonData.isSSO = this.getUserSettingsCookie("isSSO");
        if (this.isUndefOrNull(jsonData.isSSO)) {
            jsonData.isSSO = false;
        }

        // build json string based on json data
        const jsonDataString = this.isUndefOrNull(jsonData) ? "" : JSON.stringify(jsonData);

        console.info("cacheableAjaxService is called. {serviceUrl: " + serviceUrl + ", jsonData: " + jsonDataString + "}");

        // create a unique post identifier based on serivce url and json data
        const uid = serviceUrl + "@" + jsonDataString;

        // find the cached key based on the unique identifier of the request
        const cachedKey = this.keyCache.get(uid);

        // append cachedKey as a request parameter and get value based on key
        let value = null;
        if (!this.isUndefOrNullOrEmpty(cachedKey)) {
            jsonData.cachedKey = cachedKey;
            value = this.dataCache.get(cachedKey);
        } else {
            jsonData.cachedKey = null;
        }
        jsonData.clientType = 0;
        // if the data value is cached in the client-side cache, we will call success callback immediately, and then try
        // to send the reqeust to the server and see if there is any update to the cached data; if any, when we receive
        // the new data, we call the success callback again to tell the client that new data is acquired; otherwise, do
        // nothing.
        if (!this.isUndefOrNull(value)) {
            // record current location for later use
            const curLocation = window.location.href;

            console.info("Data is found from client-side cache, and call success callback with cached data. {uid: " + uid + ", location: " + curLocation + ", cache size: " + "}");

            // call success call back
            if (!this.isUndefOrNull(successCallback)) successCallback(value);

            setTimeout(() => {
                const newLocation = window.location.href;

                console.info("Start to check the validity of cached data. {uid: " + uid + ", location: " + newLocation + "}");

                if (curLocation !== window.location.href) {
                    // do not do anything since the page is changed
                    // there is no need to find out if new data is there

                    console.info("Cancel the validity checking since the location is changed. {uid: " + uid + ", oldLocation: " + curLocation + ", newLocation: " + newLocation + "}");

                    return;
                }

                this.callAjax(
                    this.api,
                    serviceUrl,
                    jsonData,
                    (response) => {
                        // if any new data, then call success callback
                        // otherwise, do nothing
                        if (cachedKey !== response.cachedKey) {
                            console.info("Cached data is updated by others. {uid: " + uid + "}");

                            // remove old cached data since we don't need it any more.
                            this.dataCache.remove(cachedKey);

                            console.info("Old cached data is removed from the cache. {uid: " + uid + "}");

                            if (response.cachedKey !== null && response.cachedKey !== "") {
                                // update the cache key to the key cache
                                this.keyCache.set(uid, response.cachedKey);

                                // update the data to the data cache
                                this.dataCache.set(response.cachedKey, response);

                                console.info("Cached data is updated for this service call. {uid: " + uid + ", cachedKey:" + response.cachedKey + "}");
                            }

                            // call sucdess callback for newly updated data
                            if (!this.isUndefOrNull(successCallback)) successCallback(response);
                        } else {
                            console.info("Cached data is up-to-date. {uid: " + uid + "}");
                        }
                    },
                      (response) => {
                        if (!this.isUndefOrNull(failureCallback)) failureCallback(response);
                    }
                );
            }, this.validityCheckDelay);
        } else {
            this.callAjax(
                this.api,
                serviceUrl,
                jsonData,
                (response) => {
                    if (!this.isUndefOrNullOrEmpty(response.cachedKey)) {
                        // add new cached key to the key cache
                        this.keyCache.set(uid, response.cachedKey);

                        // add new data to the data cache
                        this.dataCache.set(response.cachedKey, response);

                        console.info("Data is added to the cache for this service call. {uid: " + uid + ", cachedKey:" + response.cachedKey + ", cache size: " + "}");
                    }

                    // call sucdess callback for newly updated data
                    if (!this.isUndefOrNull(successCallback)) successCallback(response);
                },
                  (response) => {
                    if (!this.isUndefOrNull(failureCallback)) failureCallback(response);
                }
            );
        }
    };

    post = (serviceUrl, jsonData, successCallback, failureCallback) => {
        this.ajax(serviceUrl, jsonData, successCallback, failureCallback);
    };

    get = (serviceUrl, successCallback, failureCallback) => {
        this.ajax(serviceUrl, null, successCallback, failureCallback);
    };

    isUndefOrNull =   (obj) => {
        if (typeof obj == "undefined" || obj === null) {
            return true;
        }

        return false;
    };

    isUndefOrNullOrEmpty =   (obj) => {
        if (typeof obj == "undefined" || obj === null || obj === "") {
            return true;
        }

        return false;
    };

    formatString = function () {
        // The string containing the format items (e.g. "{0}")
        // will and always has to be the first argument.
        let str = arguments[0];

        // start with the second argument (i = 1)
        for (let i = 1; i < arguments.length; i++) {
            // "gm" = RegEx options for Global search (more than one instance)
            // and for Multiline search
            const regEx = new RegExp("\\{" + (i - 1) + "\\}", "gm");
            str = str.replace(regEx, arguments[i]);
        }

        return str;
    };

    getServiceUrl = (className, methodName, paramType) => {
        const serviceNdx = window.localStorage.getItem("JwtTokenIndexForSPA");
        return this.formatString(this.getServicePrefix(serviceNdx) + serviceUrl, className, methodName, paramType, window.location.href);
    };

    getServicePrefix =   (serviceNdx) => {
        let httpPrefix = "";

        const jwtServiceToken = window.localStorage.getItem("JwtTokenForSPA");
        if (!jwtServiceToken || jwtServiceToken === "" || !serviceNdx || serviceNdx < 0 || !window.g_serviceDomains || window.g_serviceDomains === "") {
            return httpPrefix;
        }

        // do not use service prefix for https pages
        if (window.location.protocol !== "https:") {
            const serviceDomains = window.g_serviceDomains.split(";");
            if (serviceDomains && serviceDomains.length > 0 && serviceNdx && serviceNdx > -1) {
                //alert('length: ' + serviceDomains.length);

                let domainNdx = 0;
                if (serviceNdx) {
                    domainNdx = serviceNdx % serviceDomains.length;
                }

                httpPrefix = "http://" + serviceDomains[domainNdx];

                //alert('domainNdx: ' + domainNdx);
            }
        }

        return httpPrefix;
    };

    getWritableSessionServiceUrl = (className, methodName, paramType) => {
        //
        // add a hack when people is going to write session like login
        // to make sure token is cleared
        //
        window.localStorage.setItem("JwtTokenForSPA", "");

        return this.formatString(serviceUrlWithWritableSession, className, methodName, paramType, window.location.href);
    };

    detectIsMobileDevice =   () =>{
        //for now we treat window width < 768 as mobile device
        var sUserAgent = window.navigator.userAgent.toLowerCase();
        var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
        var bIsMidp = sUserAgent.match(/midp/i) == "midp";
        var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
        var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
        var bIsAndroid = sUserAgent.match(/android/i) == "android";
        var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
        var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
        var bSmallScreen = window.innerWidth < 768;
        if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM || bSmallScreen) {
            return true;
        }
        return false;
    };

    getUserSettingsCookie =   (name) =>{
        var value = null;
        const cookies = new Cookies(null, { path: '/' });

        var userSetting = cookies.get('IMUserSetting');
        if (!this.isUndefOrNull(userSetting)) {
            _.forEach(userSetting,   (val, key)=> {
                if (name === key) {
                    value = val;
                }
            });
        }
        return value;
    };

    _formalizeError(data, problem) {
        let message = "Unknow error.";
        if (problem && problem !== "") {
            message = problem;
        }

        if (!data) {
            return { code: 1, message: message };
        }

        if (_.isString(data)) {
            return { code: 1, message: data };
        }

        const error = { ...data };

        if (!_.has(error, "code")) {
            error.code = 1; // Unknow
        }

        if (!_.has(error, "message")) {
            error.message = message;
        }

        return error;
    }
}


const cApiService = window.IS_ELECTRON ? new AjaxServiceElectron() : new AjaxService();
window.imlApiService = cApiService;
export default cApiService;
